<app-modal-alertas></app-modal-alertas>

<div *ngIf="isLoading" class="loading-overlay">
  <div
    class="spinner-border"
    role="status"
    style="width: 5rem; height: 5rem; border-width: 0.3rem"
  >
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div id="section-1" class="section1">
  <div class="container mt-3 d-flex justify-content-center">
    <div class="w-100" style="max-width: 1200px">
      <div *ngIf="errorMsg" class="alert alert-danger my-3 text-center">
        {{ errorMsg }}
      </div>
      <div *ngIf="isLoading" class="loading-overlay">
        <div
          class="spinner-border"
          role="status"
          style="width: 5rem; height: 5rem; border-width: 0.3rem"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div *ngIf="!isLoading && !errorMsg">
        <!-- Declaración previa a la tabla -->
        <div class="alert alert-primary mb-3 text-center" style="white-space: pre-line;">
          <b>Declaración Jurada Simple<br>
          Información financiera</b><br>
          <div class="mb-3" style="text-align: justify; white-space: pre-line;">
            Yo, Rut N° {{ repRut || 'Sin Rut'  }}, en mi calidad de Representante Legal de la empresa 
            {{ sujetoNombre }}, Rut N° {{ sujetoRut }}, declaro que:<br>
            Por el presente la empresa individualizada anteriormente manifiesta que, los antecedentes
            detallados a continuación, son fidedignos para ser utilizados en la evaluación financiera de
            contribuyentes acogidos a contabilidad simplificada y, eventualmente, son
            los siguientes:
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered align-middle mx-auto">
            <thead class="table-light">
              <tr>
                <th scope="col">Codigo</th>
                <th scope="col">Concepto</th>
                <th scope="col" *ngFor="let periodo of periodos">
                  Saldo al 31-dic-{{ periodo }} Cifras<br />
                  en Pesos $
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let fila of filas">
                <td>{{ fila.codigo }}</td>
                <td>{{ fila.glosa }}</td>
                <td *ngFor="let periodo of periodos">
                  <ng-container
                    *ngIf="
                      editableData[periodo] &&
                        editableData[periodo][fila.codigo] !== undefined;
                      else noExiste
                    "
                  >
                    <input
                      type="number"
                      class="form-control"
                      [ngClass]="{'is-invalid': editableData[periodo][fila.codigo] === null}"
                      [ngModel]="editableData[periodo][fila.codigo]"
                      (ngModelChange)="onValorChange(periodo, fila.codigo, $event)"
                      style="max-width: 230px"
                    />
                  </ng-container>
                  <ng-template #noExiste>
                    <span class="text-danger fw-bold text-center d-block">X</span>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Declaración adicional y campo de monto -->
          <div class="alert alert-secondary mt-3">
            De igual manera declaro que NO se efectuarán retiros de las reservas declaradas en el
            Patrimonio como susceptibles de ser retiradas, y en el caso de realizarse retiros desde dichas
            reservas estos lo serán por un monto máximo de
          <input
              type="text"
              appNumberFormatNoSum
              class="form-control d-inline-block"
              [ngClass]="{'is-invalid': montoReservas === null || montoReservas < 0 || montoReservas > maxInt4}"
              style="width: 250px; margin-left: 5px; margin-right: 5px;"
              [ngModel]="montoReservas"
              (input)="limitarMaximo($event)"
              placeholder="$"
              required
            />
          </div>
          <div *ngIf="!isFormComplete()" class="alert alert-warning text-center mt-2">
            Es obligatorio rellenar todas las casillas existentes, en el caso de no registrar saldo, indicar $0.
          </div>
          <div class="col-12 d-flex justify-content-center mb-1 align-content-center">
            <button
              class="btn btn-guardar"
              (click)="guardarCambios()"
              [disabled]="
                !replaceChecked ||
                !isFormComplete() ||
                montoReservas === null ||
                montoReservas < 0 ||
                montoReservas > maxInt4
              "
            >
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
